import FlightDetailsItem from './FlightDetailsItem.js';
import { Container, TagContainer, InnerContainer, OverlayButton, FlightDetailsItemsList } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Tag from '../Tag/Tag.js';

var FlightDetails = function FlightDetails(_ref) {
  var transportOffers = _ref.transportOffers,
    texts = _ref.texts,
    children = _ref.children,
    toggleFlightDetails = _ref.toggleFlightDetails,
    out = _ref.out,
    home = _ref.home;
  if (!transportOffers || !transportOffers.length) {
    return false;
  }
  var selectedTransport = transportOffers[0];
  var classPriority = ['P', 'F'];
  var selectedIsUpgraded = classPriority.indexOf(selectedTransport && selectedTransport.className) !== -1;
  var classUpgradeCode = selectedIsUpgraded ? selectedTransport && selectedTransport.className : classPriority.find(function (code) {
    return transportOffers.find(function (offer) {
      return offer.className === code;
    });
  });
  var classUpgrade = transportOffers.find(function (offer) {
    return offer && offer.className === classUpgradeCode;
  });

  // Is it just one offer or selected is an upgrade --> show included
  var classLabel = transportOffers.length > 1 && !selectedIsUpgraded ? texts.available : texts.included;
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsxs(TagContainer, {
      children: [selectedTransport.freeSeats && selectedTransport.freeSeats < 9 && texts.seatLeft && texts.seatsLeft && /*#__PURE__*/jsx(Tag, {
        variant: "red",
        small: true,
        children: selectedTransport.freeSeats === 1 ? texts.seatLeft : texts.seatsLeft
      }), classUpgrade && /*#__PURE__*/jsxs(Tag, {
        variant: "black",
        small: true,
        children: [classUpgrade && classUpgrade.transportContent.name, " ", classLabel]
      })]
    }), /*#__PURE__*/jsxs(InnerContainer, {
      children: [toggleFlightDetails && /*#__PURE__*/jsx(OverlayButton, {
        onClick: toggleFlightDetails,
        type: "button"
      }), /*#__PURE__*/jsxs(FlightDetailsItemsList, {
        children: [/*#__PURE__*/jsx(FlightDetailsItem, {
          flight: out,
          texts: texts,
          date: "".concat(texts && texts.outbound, " ").concat(out && out.departureDateTimeLocal["long"]),
          stops: out && out.numberOfStops,
          onClick: toggleFlightDetails
        }), /*#__PURE__*/jsx(FlightDetailsItem, {
          flight: home,
          texts: texts,
          date: "".concat(texts && texts.homebound, " ").concat(home && home.departureDateTimeLocal["long"]),
          stops: home && home.numberOfStops,
          onClick: toggleFlightDetails,
          homeBound: true
        })]
      })]
    }), children]
  });
};
FlightDetails.defaultProps = {
  children: null,
  toggleFlightDetails: null
};
var FlightDetails$1 = FlightDetails;

export { FlightDetails$1 as default };
//# sourceMappingURL=FlightDetails.js.map
